define('AdvancedSearch.EntryPoint',
  [
    'AdvancedSearch.Header.View'
  ],
  function (
    AdvancedSearchHeaderView
  ) {

    'use strict';

    function reformatModel(model) {
      var replaceableCharacters = [{
        character: '-SLASH-',
        encodedValue: '/'
      },
      {
        character: '-AND-',
        encodedValue: '&(?!amp;)'
      },
      {
        character: '%2C',
        encodedValue: ','
      },
      {
        character: '%27',
        encodedValue: "'"
      },
      {
        character: 'GTV6',
        encodedValue: 'GTV-6'
      },
      {
        character: '-',
        encodedValue: ' '
      },
      {
        character: '~',
        encodedValue: '-'
      },
      {
        character: '%22',
        encodedValue: '"'
      },
      {
        character: '%2B',
        encodedValue: '+'
      }
      ];

      var valueToReturn = model;
      _.each(replaceableCharacters, function (replaceableCharacter) {
        var expression = new RegExp(replaceableCharacter.character, 'g');
        valueToReturn = valueToReturn ? valueToReturn.replace(expression, replaceableCharacter.encodedValue) : valueToReturn;
      });

      return valueToReturn;
    }

    return {
      mountToApp: function mountToApp(container) {
        var layout = container.getComponent('Layout');
        var environment = container.getComponent('Environment');
        var advancedSearchConfig = environment && environment.getConfig('AdvancedSearch') || null;
        var showAdvancedSearch = environment && environment.getConfig('AdvancedSearch.showSearch') || false;

        if (layout && advancedSearchConfig && showAdvancedSearch) {
          layout.addChildView('SiteSearch', function () {
            return new AdvancedSearchHeaderView({
              container: container,
              advancedSearchConfig: advancedSearchConfig
            });
          });

          layout.addToViewContextDefinition('Facets.FacetsDisplay.View', 'values', 'array', function (context) {
            _.each(context.values, function (elem) {
              elem.valueLabel = reformatModel(elem.valueLabel);
            });
            return context.values;
          });
        }
      }
    };
  });
